import React, { FC } from 'react';
import Button, {
  ButtonArrowType,
  ButtonSizeType,
  ButtonStyleType,
  ButtonType,
} from '@/common/components/Button/Button';
import styles from './Opportunity.module.scss';

interface OpportunityAddressProps {
  country_id?: string;
  city?: string;
  state?: string;
}

export interface OpportunityProps extends OpportunityAddressProps {
  id: string;
  title: string;
  department?: string;
  board_code: string;
  job_url: string;
}

const getAddress = ({ country_id, city, state }: OpportunityAddressProps): string => {
  if (!country_id && !state && !city) {
    return '';
  }
  const addressParts = [
    city, state, country_id,
  ];

  const address = addressParts.reduce((name, addressPart) => {
    if (!addressPart) {
      return name;
    }

    return `${name ? `${name}, ` : ''}${addressPart}`;
  }, '');

  return address || '';
};

const buttonConfig = {
  type: ButtonType.myAccount,
  styleType: ButtonStyleType.link,
  size: ButtonSizeType.sm,
};

const Opportunity: FC<OpportunityProps> = ({
  title,
  department,
  job_url,
  ...address
}) => (
  <div className={styles.container}>
    {!!title && (
      <Button
        additionalAttributes={{ target: '_blank' }}
        arrowType={ButtonArrowType.right}
        buttonStylesConfig={buttonConfig}
        customClassNames={{ button: styles.title }}
        href={job_url}
        text={title}
      />
    )}
    {!!department && (
      <div className={styles.department}>
        {department}
      </div>
    )}
    <div className={styles.address}>
      {getAddress(address)}
    </div>
  </div>
);
Opportunity.displayName = 'Opportunity';

export default Opportunity;
